<template>
    <div class="cell">
        <div class="grid-x grid-padding-x">
            <div class="cell"><h2 v-html="props.article.publication" /></div>
            <div class="medium-7 cell">
                <a v-if="props.article.product.uri" :href="props.article.product.uri"><span v-html="props.article.image"></span></a>
                <span v-else v-html="props.article.image"></span>
            </div>
            <div class="medium-5 cell">
                <div class="grid-x">
                <div class="cell" v-if="props.article.collection == false">
                    <p v-if="props.article.product.title">Featured Product -</p>
                    <p v-if="props.article.product.title"><a :href="props.article.product.uri">{{ props.article.product.title }}</a></p>
                </div>
                <div class="cell" v-else>
                    <p v-if="props.article.product.title">Featured Collection -</p>
                    <p v-if="props.article.product.title"><a :href="props.article.product.uri">{{ props.article.product.title }}</a></p>
                </div>

                <p v-if="props.article.article"><a :href="props.article.article" target="_blank">Read the article</a></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
    const props = defineProps([ 'article' ])
</script>